import { createEntityAdapter } from '@reduxjs/toolkit';
import { schema } from 'normalizr';
import { RootState } from 'redux/store';
import { ProjectResponse } from 'types/entity/project-response';

export const projectSchema = new schema.Entity(
  'projects',
  {},
  { idAttribute: (value: ProjectResponse) => value.project_id || '' },
);

export const projectAdapter = createEntityAdapter<ProjectResponse>({
  selectId: (model) => model.project_id || '',
});

export const {
  selectById: selectProjectById,
  selectIds: selectProjectIds,
  selectEntities: selectProjectEntities,
  selectAll: selectAllProject,
  selectTotal: selectTotalProject,
} = projectAdapter.getSelectors<RootState>((state) => state.projectRead);
